import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getNames } from 'country-list';
import './become-a-dealer.css';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const businessTypeOptions = [
    "Retailer Retail Storefront",
    "Manufacturing Retailer / Franchiset",
    "Manufacturing Trade / Trader / Distributor",
    "Other",
];

const BecomeADealer = () => {
    const countries = getNames();

    const [formData, setFormData] = useState({
        companyName: '',
        companyPerson: '',
        position: '',
        email: '',
        website: '',
        address: '',
        city: '',
        country: 'United Arab Emirates',
        postCode: '',
        productsDealingIn: '',
        establishedSince: '',
        businessTypeOther: '',
        message: ''
    });

    const [businessTypes, setBusinessTypes] = useState([]);
    const [phone, setPhone] = useState("");
    const [formStatus, setFormStatus] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const formRef = useRef();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleBusinessTypeChange = (option) => {
        setBusinessTypes(prev =>
            prev.includes(option)
                ? prev.filter(item => item !== option)
                : [...prev, option]
        );
    };

    const sendDealerEmail = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-dealer-form`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName: formData.companyName,
                    companyPerson: formData.companyPerson,
                    position: formData.position,
                    phoneNo: phone,
                    email: formData.email,
                    website: formData.website,
                    address: formData.address,
                    city: formData.city,
                    country: formData.country,
                    postCode: formData.postCode,
                    productsDealingIn: formData.productsDealingIn,
                    establishedSince: formData.establishedSince,
                    businessTypes: businessTypes,
                    businessTypeOther: formData.businessTypeOther,
                    message: formData.message
                })
            });

            const result = await response.json();

            if (result.success) {
                setFormSuccess(true);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);

                setFormData({
                    companyName: '',
                    companyPerson: '',
                    position: '',
                    email: '',
                    website: '',
                    address: '',
                    city: '',
                    country: 'United Arab Emirates',
                    postCode: '',
                    productsDealingIn: '',
                    establishedSince: '',
                    businessTypeOther: '',
                    message: ''
                });
                setBusinessTypes([]);
                setPhone("");
            } else {
                setFormSuccess(false);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);
            }
        } catch (err) {
            console.error(err);
            setFormSuccess(false);
            setFormStatus(true);
            setTimeout(() => setFormStatus(false), 5000);
        }
    };

    return (
        <div className="dealer-FromPage">
            <div className="dealer-form-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Become A Dealer</h1>
                    <nav className="dealer-breadcrumb" style={{ margin: '4px 0 20px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                        <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                        <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                        <span>Become A Dealer</span>
                    </nav>
                    <p className="Sep-subtitle">If you wish to become a Callistus Dealer, please fill out the first-hand information as requested below.</p>
                </div>

                <form ref={formRef} onSubmit={sendDealerEmail}>
                    {/* Company Name */}
                    <div className="form-group">
                        <label htmlFor="companyName">Company Name*</label>
                        <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Company Person */}
                    <div className="form-group">
                        <label htmlFor="companyPerson">Company Person*</label>
                        <input
                            type="text"
                            id="companyPerson"
                            name="companyPerson"
                            value={formData.companyPerson}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Position In Company */}
                    <div className="form-group">
                        <label htmlFor="position">Position In Company*</label>
                        <input
                            type="text"
                            id="position"
                            name="position"
                            value={formData.position}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Phone + Email + Website */}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="phoneNo">Phone No.*</label>
                            <PhoneInput
                                country={"ae"}
                                enableSearch={true}
                                value={phone}
                                onChange={(phone) => setPhone(phone)}
                                placeholder=""
                                inputProps={{
                                    name: 'phoneNo',
                                    required: true
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email*</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="website">Company Website</label>
                            <input
                                type="text"
                                id="website"
                                name="website"
                                placeholder="E.g. http://www.example.com"
                                value={formData.website}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Company Address */}
                    <div className="form-group">
                        <label htmlFor="address">Company Address*</label>
                        <input
                            type="text"
                            id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* City + Country + Post Code */}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="city">City / Area*</label>
                            <input
                                type="text"
                                id="city"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="country">Country*</label>
                            <select
                                id="country"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                            >
                                {countries.map((country, idx) => (
                                    <option value={country} key={idx}>{country}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="postCode">Post Code*</label>
                            <input
                                type="text"
                                id="postCode"
                                name="postCode"
                                value={formData.postCode}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Products dealing in + Established Since */}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="productsDealingIn">Products dealing in</label>
                            <input
                                type="text"
                                id="productsDealingIn"
                                name="productsDealingIn"
                                value={formData.productsDealingIn}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="establishedSince">Established Since</label>
                            <input
                                type="text"
                                id="establishedSince"
                                name="establishedSince"
                                value={formData.establishedSince}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Business Type */}
                    <div className="form-group">
                        <label>Business Type</label>
                        <div className="checkbox-group">
                            {businessTypeOptions.map((option, idx) => (
                                <div className="checkbox-option" key={idx}>
                                    <input
                                        type="checkbox"
                                        id={`businessType-${idx}`}
                                        checked={businessTypes.includes(option)}
                                        onChange={() => handleBusinessTypeChange(option)}
                                    />
                                    <label htmlFor={`businessType-${idx}`}>{option}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Other business type - specify */}
                    <div className="form-group">
                        <input
                            type="text"
                            id="businessTypeOther"
                            name="businessTypeOther"
                            placeholder="If Other, please specify"
                            value={formData.businessTypeOther}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Message */}
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            rows={5}
                            value={formData.message}
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    {/* Success/Error Message */}
                    <div className="form-notify">
                        {formStatus && formSuccess && (
                            <p className="notify-text success">Your form has been submitted successfully!</p>
                        )}
                        {formStatus && !formSuccess && (
                            <p className="notify-text error">There was an error submitting your form. Please try again.</p>
                        )}
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="submit-btn">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default BecomeADealer;